// extracted by mini-css-extract-plugin
export default {"Features":"Features_Features__eehFp"};